import React, { Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ConfirmationModal from "../ConfirmationModal";
// import Disclaimer from "../Disclaimer";
import {
  BlockchainName,
  DepositMethods,
  UserBalances,
  // DepositMethodAndUserBalance,
} from "../../typings";
import EventManager from "../../utils/EventManager";

type Args = {
  withdrawMethods: DepositMethods;
  userBalances: UserBalances;
  selectedBlockchainName: BlockchainName | "";
  events: EventManager;
  closeMainModal: any;
};

export default function WithdrawContent({
  withdrawMethods,
  userBalances,
  selectedBlockchainName,
  events,
  closeMainModal
}: Args) {
  const [isOpen, setIsOpen] = useState(false);
  const [address, setAddress] = useState("");
  const [amount, setAmount] = useState("");
  // const [withdrawMethodAndUserBalance, setWithdrawMethodAndUserBalance] =
  //   useState<DepositMethodAndUserBalance | null>(null);
  // const [maxAmountCrypto, setMaxAmountCrypto] = useState<string>("0");
  const [maxAmountFiat, setMaxAmountFiat] = useState<string>("0");

  function mergeWithdrawMethodsAndUserBalances() {
    for (const withdrawMethod of withdrawMethods) {
      const userBalance = userBalances.find(
        (userBalance) =>
          userBalance.blockchainName === withdrawMethod.blockchain.name
      );

      if (!userBalance) {
        continue;
      }

      // setWithdrawMethodAndUserBalance({
      //   ...withdrawMethod,
      //   fiat: userBalance.fiat,
      //   value: userBalance.value,
      // });
      // setMaxAmountCrypto(userBalance.value);
      setMaxAmountFiat(userBalance.fiat.usd);
    }
  }

  useEffect(() => {
    mergeWithdrawMethodsAndUserBalances();
  }, [withdrawMethods, userBalances, selectedBlockchainName]);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  function renderAddElement(element: any) {
    if (!address)
      return (
        <span className="mt-2 text-red-500 text-sm">
          Please provide an {element}.
        </span>
      );
    return null;
  }

  function renderAmElement(element: any) {
    if (!amount)
      return (
        <span className="mt-2 text-red-500 text-sm">
          Please provide an {element}.
        </span>
      );
    return null;
  }

  function handleOnMax() {
    event?.preventDefault();
    setAmount(maxAmountFiat);
  }

  return (
    <Fragment>
      <div className="">
        <div>
          {/* <Disclaimer text={"test test 12345"} /> */}

          <label
            className="block text-white text-sm font-bold mb-2 mt-6"
            htmlFor="address"
          >
            Address <span className="text-red-500">*</span>
          </label>

          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="address"
            type="text"
            placeholder="Your Address"
            onChange={(e) => {
              setAddress(e.target.value);
            }}
            value={address}
          />
          {renderAddElement("Address")}

          <div className="flex justify-between mb-2 mt-6">
            <label
              className="block text-white text-sm font-bold"
              htmlFor="amount"
            >
              Amount (USD) <span className="text-red-500">*</span>
            </label>
            <span className="text-white text-sm font-bold">
              (${maxAmountFiat})
            </span>
          </div>

          <div className="flex">
            <input
              className="shadow appearance-none border rounded-l-sm w-5/6 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="amount"
              type="number"
              placeholder="Amount to withdraw"
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              value={amount}
            />
            <button
              type="button"
              onClick={handleOnMax}
              className="rounded-r-sm border border-blue text-white text-sm font-bold w-1/6 hover:bg-blue-800 hover:text-white"
            >
              Max
            </button>
          </div>
          {renderAmElement("Amount")}

          <div className="flex justify-center">
            <button
              type="button"
              onClick={openModal}
              disabled={!address || !amount}
              className="mt-6 rounded-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
            >
              Withdraw
            </button>
          </div>
        </div>

        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>
            <ConfirmationModal
              closeModal={closeModal}
              blockchainName={selectedBlockchainName}
              address={address}
              amount={amount}
              events={events}
              closeMainModal={closeMainModal}
            ></ConfirmationModal>
          </Dialog>
        </Transition>
      </div>
    </Fragment>
  );
}
